export default "__VITE_ASSET__Cu6_Yyia__"